import { useSelector } from "react-redux";

import type { RootState } from "@/store";

/**
 * True while any onboarding tour is active.
 *
 * Generic gate for behavior that should pause for every module (e.g. blocking a
 * background refetch). Module-specific seams should prefer the scoped variant
 * below so one module's fixtures never leak into another's tour.
 */
export function useOnboardingActive(): boolean {
  return useSelector((state: RootState) => state.onboarding.active);
}
